import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Отправьте остальные вещи на трансфер ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check = _resolveComponent("check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_MoveMaster = _resolveComponent("MoveMaster")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, [
      _hoisted_1,
      (_ctx.isAllTransfer)
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            size: "40px",
            color: "green"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_check)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isTransfer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MoveMaster, {
            "prop-options": { destination: 1, type: 'nw-h' },
            "url-set": "/storage/moving-to-transfer",
            onSuccessMoveMaster: _ctx.success,
            onNextMoveMaster: _ctx.next
          }, null, 8, ["onSuccessMoveMaster", "onNextMoveMaster"]),
          _createElementVNode("div", null, "Перемещено " + _toDisplayString(_ctx.getCountInStorage) + " из " + _toDisplayString(_ctx.getCountOriginalQuantity), 1)
        ]))
      : (_ctx.product?.variations.some(el => el.state === _ctx.enumVariationState.moving))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Все товары перемещены на трансфер "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "Редактирование зоны трансфера недоступно"))
  ], 64))
}